import { ComponentModel } from '../../models';
import { getPriceRange } from './utils/getPriceRange';
import { SerializedComponent } from './types';

export const serializeComponents = (components: ComponentModel[]) => {
  return components
    .filter(
      (component) =>
        !['metered', 'prepaid'].includes(component.type) &&
        component.updatesAllowed
    )
    .map((component) => {
      const {
        id,
        name,
        type,
        allocatedQuantity,
        description,
        currency,
        pricePoint,
        unit,
        recurring,
        allowFractionalQuantities,
        updatesAllowed,
      } = component;
      const serializedComponent = {
        id,
        name,
        type,
        description,
        recurring,
        unitName: unit.name,
        allocatedQuantity,
        allowFractionalQuantities,
        memo: '',
        updatesAllowed,
        price: getPriceRange(pricePoint.type, pricePoint.prices, currency),
      } as SerializedComponent;

      return serializedComponent;
    });
};
